import * as i0 from '@angular/core';
import { Input, Component, input, computed, HostBinding, Directive } from '@angular/core';
function AnimatedTestimonialCardComponent_For_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 6);
    i0.ɵɵelement(1, "path", 9);
    i0.ɵɵelementEnd();
  }
}
let AnimatedTestimonialCardComponent = /*#__PURE__*/(() => {
  class AnimatedTestimonialCardComponent {
    constructor() {
      this.stars = Array.from({
        length: 5
      });
    }
    static {
      this.ɵfac = function AnimatedTestimonialCardComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AnimatedTestimonialCardComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AnimatedTestimonialCardComponent,
        selectors: [["nc-animated-testimonial-card"]],
        inputs: {
          info: "info"
        },
        decls: 12,
        vars: 4,
        consts: [[1, "animatedTestimonialCard"], [1, "animatedTestimonialCard__image"], [3, "src", "alt"], [1, "animatedTestimonialCard__testimonial"], [1, "animatedTestimonialCard__stars"], ["aria-label", "5 stars rating"], ["alt", "Star", "aria-hidden", "true", "width", "21", "height", "19", "viewBox", "0 0 21 19", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "animatedTestimonialCard__star"], [1, "animatedTestimonialCard__text"], [1, "animatedTestimonialCard__name"], ["d", "M10.8594 15.2434L17.0364 18.9297L15.4423 11.9556L20.8223 7.17335L13.649 6.57557L10.8594 0L8.06971 6.57557L0.896362 7.17335L6.37601 11.9556L4.78193 18.9297L10.8594 15.2434Z", "fill", "#72035D"]],
        template: function AnimatedTestimonialCardComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵelement(2, "img", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 3)(4, "div", 4)(5, "div", 5);
            i0.ɵɵrepeaterCreate(6, AnimatedTestimonialCardComponent_For_7_Template, 2, 0, ":svg:svg", 6, i0.ɵɵrepeaterTrackByIndex);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "p", 7);
            i0.ɵɵtext(9);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "p", 8);
            i0.ɵɵtext(11);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("src", ctx.info.imageUrl, i0.ɵɵsanitizeUrl)("alt", ctx.info.name);
            i0.ɵɵadvance(4);
            i0.ɵɵrepeater(ctx.stars);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.info.text);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.info.name);
          }
        },
        styles: [".animatedTestimonialCard[_ngcontent-%COMP%]{position:relative;display:grid;grid-template-areas:\"cards\"}@media only screen and (height <= 630px){.animatedTestimonialCard[_ngcontent-%COMP%]{margin-bottom:150px}}@media only screen and (height >= 800px){.animatedTestimonialCard[_ngcontent-%COMP%]{margin-top:12vh}}@media only screen and (min-width: 768px){.animatedTestimonialCard[_ngcontent-%COMP%]{margin-top:0}}.animatedTestimonialCard__image[_ngcontent-%COMP%]{grid-area:cards;background-color:#fff;box-shadow:0 -5px 20px #1a1a1a1a;border-radius:4px;max-height:315px;max-width:258px;padding:16px 16px 60px;transform:rotate(-12deg);margin-bottom:24px;z-index:0;opacity:0;animation:_ngcontent-%COMP%_slide-right .7s cubic-bezier(.2,.8,.2,1);animation-fill-mode:forwards}.animatedTestimonialCard__image[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:100%;object-fit:cover;border-radius:4px}.animatedTestimonialCard__testimonial[_ngcontent-%COMP%]{margin-bottom:24px;grid-area:cards;background-color:#fff;padding:56px 30px 40px;box-shadow:0 -5px 20px #1a1a1a1a;border-radius:4px;max-height:315px;max-width:256px;display:flex;flex-direction:column;z-index:1;opacity:0;animation:_ngcontent-%COMP%_slide-left .6s cubic-bezier(.2,.8,.2,1) 1.4s;animation-fill-mode:forwards}.animatedTestimonialCard__stars[_ngcontent-%COMP%]{margin-bottom:24px;display:flex;flex-direction:row;justify-content:center}.animatedTestimonialCard__star[_ngcontent-%COMP%]{margin-right:8px}.animatedTestimonialCard__text[_ngcontent-%COMP%]{font-weight:400;line-height:1.5em;letter-spacing:0;font-size:calc(1.6 / var(--rem-base) * 1rem);text-align:center}.animatedTestimonialCard__name[_ngcontent-%COMP%]{letter-spacing:-.02em;font-weight:800;line-height:1.35em;font-size:calc(1.6 / var(--rem-base) * 1rem);text-align:center;text-transform:capitalize}@keyframes _ngcontent-%COMP%_slide-right{0%{transform:translate(-150%) rotate(-35deg)}1%{opacity:1}90%{transform:translate(5%) rotate(-9deg);opacity:1}to{transform:translate(0) rotate(-12deg);opacity:1}}@keyframes _ngcontent-%COMP%_slide-left{0%{transform:translate(150%) rotate(-30deg);opacity:0}1%{opacity:1}90%{transform:translate(-5%) rotate(-3deg)}to{transform:translate(0);opacity:1}}"]
      });
    }
  }
  return AnimatedTestimonialCardComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DatoImageDirective = /*#__PURE__*/(() => {
  class DatoImageDirective {
    constructor() {
      /**
       * The source received from "Copy URL" on the asset in DatoCMS
       */
      this.src = input.required();
      /**
       * Corresponds to the "w" param in imgix. Basically the width we fetch the image at.
       */
      this.imgixWidth = input.required();
      this.processedSrc = computed(() => {
        const src = this.src();
        const url = this.toURLOrUndefined(src);
        if (!url) {
          return src;
        }
        const {
          searchParams
        } = url;
        const existingAutoParam = searchParams.get("auto");
        // Consumer can override auto if they'd like. One needs to know what one is doing to get to that point.
        if (!existingAutoParam) {
          searchParams.set("auto", "format");
        } else if (!existingAutoParam.includes("format")) {
          searchParams.set("auto", `${existingAutoParam},format`);
        }
        const existingWidthParam = searchParams.get("w");
        if (!existingWidthParam) {
          searchParams.set("w", this.imgixWidth().toString());
        }
        const existingQualityParam = searchParams.get("q");
        if (!existingQualityParam) {
          searchParams.set("q", "80");
        }
        return url.toString();
      });
    }
    get outputSrc() {
      return this.processedSrc();
    }
    toURLOrUndefined(href) {
      if (!href) return;
      try {
        return new URL(href);
      } catch {
        return;
      }
    }
    static {
      this.ɵfac = function DatoImageDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DatoImageDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: DatoImageDirective,
        selectors: [["", "datoImage", ""]],
        hostVars: 1,
        hostBindings: function DatoImageDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵdomProperty("src", ctx.outputSrc, i0.ɵɵsanitizeUrlOrResourceUrl);
          }
        },
        inputs: {
          src: [1, "src"],
          imgixWidth: [1, "imgixWidth"]
        }
      });
    }
  }
  return DatoImageDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AnimatedTestimonialCardComponent, DatoImageDirective };
